module.exports = __webpack_public_path__ + "img/quote-img-min.5cc1dfe3.jpg";